<template>
  <router-btn :text="$t('servicesystem.common_objects.job.hazard_analysis')" :icon="'mdi-file-alert'" :color="'primary'"
    :disabled="!JobId" outlined :textbtn="textbtn" :large="large" :small="small" @Press="action">
  </router-btn>
</template>

<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import RouterBtn from "@/components/Buttons/RouterBtn.vue";

export default {
  name: "HazardAnalysisBtn",
  props: ["large", "small", "textbtn"],
  components: { RouterBtn },
  mixins: [clientAPI],

  data() {
    return {
      loading: false,
    };
  },

  created() { },

  mounted() { },

  methods: {
    action() {
      this.loading = true;
      this.GetHazardAnalysisLink(this.$route.params.jobId, true).finally(() => {
        this.loading = false;
      });
    },
  },

  computed: {
    JobId() {
      return this.$route.params.jobId;
    },
  },

  watch: {},
};
</script>

<style lang="scss" scoped></style>
